import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=6837d39a&"
import script from "./CategoryFilters.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports